if (!customElements.get('blanc-footer-editorial')) {
  customElements.define('blanc-footer-editorial', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const button = this.querySelector('[data-editorial-cookie-settings]');
      const status = this.querySelector('[data-editorial-cookie-status]');
      const headline = this.querySelector('.blanc-footer-editorial__headline');
      const form = this.querySelector('.blanc-footer-editorial__form');
      const tabs = [...this.querySelectorAll('[data-editorial-tab]')];
      const panels = [...this.querySelectorAll('[data-editorial-panel]')];
      const mobileViewport = window.matchMedia('(max-width: 599px)');
      const wordmark = this.querySelector('[data-editorial-wordmark]');
      const wordmarkText = this.querySelector('[data-editorial-wordmark-text]');
      const mobileWordmark = this.querySelector('[data-editorial-mobile-wordmark]');
      const mobileWordmarkText = this.querySelector('[data-editorial-mobile-wordmark-text]');

      const fitWordmark = (container, text, scaleProperty) => {
        if (!container || !text) return;

        text.style.setProperty(scaleProperty, '1');
        const styles = getComputedStyle(container);
        const availableWidth = container.clientWidth
          - (parseFloat(styles.paddingLeft) || 0)
          - (parseFloat(styles.paddingRight) || 0);
        const naturalWidth = text.scrollWidth;
        if (!availableWidth || !naturalWidth) return;

        text.style.setProperty(
          scaleProperty,
          Math.max(0.1, Math.min(1, availableWidth / naturalWidth)).toFixed(4)
        );
      };

      const fitWordmarks = () => {
        fitWordmark(wordmark, wordmarkText, '--bfe-wordmark-scale');
        fitWordmark(mobileWordmark, mobileWordmarkText, '--bfe-mobile-wordmark-scale');
      };

      const fitNewsletterForm = () => {
        if (!form) return;

        if (!headline || mobileViewport.matches) {
          form.style.width = '';
          return;
        }

        const width = headline.getBoundingClientRect().width;
        if (width) form.style.width = `${width}px`;
      };

      let activeTab = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true')?.dataset.editorialTab
        || tabs[0]?.dataset.editorialTab;

      const activateTab = (name) => {
        if (!name) return;
        activeTab = name;

        tabs.forEach((tab) => {
          const selected = tab.dataset.editorialTab === name;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.editorialPanel !== name;
        });
      };

      const syncMobileTabs = () => {
        if (mobileViewport.matches) {
          activateTab(activeTab);
        } else {
          panels.forEach((panel) => {
            panel.hidden = false;
          });
        }
        fitNewsletterForm();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          if (mobileViewport.matches) activateTab(tab.dataset.editorialTab);
        }, { signal });

        tab.addEventListener('keydown', (event) => {
          if (!mobileViewport.matches || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          const nextTab = tabs[nextIndex];
          activateTab(nextTab.dataset.editorialTab);
          nextTab.focus();
        }, { signal });
      });

      mobileViewport.addEventListener('change', syncMobileTabs, { signal });
      syncMobileTabs();

      this.wordmarkResizeObserver?.disconnect();
      this.wordmarkResizeObserver = new ResizeObserver(() => {
        fitWordmarks();
        fitNewsletterForm();
      });
      if (wordmark) this.wordmarkResizeObserver.observe(wordmark);
      if (mobileWordmark) this.wordmarkResizeObserver.observe(mobileWordmark);
      if (headline) this.wordmarkResizeObserver.observe(headline);

      const fitFooter = () => {
        fitWordmarks();
        fitNewsletterForm();
      };

      requestAnimationFrame(fitFooter);
      document.fonts?.ready?.then(fitFooter);

      button?.addEventListener('click', async () => {
        if (status) status.hidden = true;

        try {
          if (typeof window.privacyBanner?.showPreferences !== 'function') {
            if (status) status.hidden = false;
            return;
          }

          await window.privacyBanner.showPreferences();
        } catch {
          if (status) status.hidden = false;
        }
      }, { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.wordmarkResizeObserver?.disconnect();
    }
  });
}
